export const version = "abi/5.4.0";
//# sourceMappingURL=_version.js.map